import { render, staticRenderFns } from "./ProvidableDriversSection.vue?vue&type=template&id=f830407a&"
import script from "./ProvidableDriversSection.vue?vue&type=script&lang=js&"
export * from "./ProvidableDriversSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QBtn,QTooltip,QTr,QTh,QTd,QCardSection,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QTable,QBtn,QTooltip,QTr,QTh,QTd,QCardSection,QInnerLoading,QSpinnerGears}, component.options.components || {})
